import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { formatNumber } from "../modules";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { green, red } from "@mui/material/colors";
import zipCar from "../../images/community2.svg";
import bitbank from "../../images/splimit.svg";
import aviato from "../../images/warning.svg";
import { notiError } from "../../utils/notiUltils";

const Items = ({ icon, title, text, value = 0, percent = 0, index = 0 }) => {
  return (
    <Box>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Box>
          <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <Avatar
              sx={{ bgcolor: "#0000000F" }}
              src={icon}
              variant="rounded"
            />
            <Stack>
              <Typography variant="body1">{title}</Typography>
              <Typography color="text.secondary" variant="caption">
                {text}
              </Typography>
            </Stack>
          </Stack>
        </Box>
        <Box minWidth={90} maxWidth={90}>
          <Stack spacing={1}>
            <Typography variant="body1">{formatNumber(value)} ครั้ง</Typography>
            <LinearProgress
              variant="determinate"
              value={percent}
              sx={{ borderRadius: 2, height: 8 }}
              color={
                index === 0 ? "info" : index === 1 ? "secondary" : "inherit"
              }
            />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

function AllNotifications({ api, reloadData, setReloadData }) {
  const [dataSource, setDataSource] = useState({});
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(false);

  useEffect(() => {
    if (!api || !reloadData || !setReloadData) {
      return;
    }
    api
      .get("/dashboard4", localStorage.getItem("token"))
      .then((data) => {        
        setStatus(false);
        setTimeout(() => {
          setDataSource(data);
          setStatus(true);
          setReloadData(false);
        }, 100);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api, reloadData, setReloadData]);

  useEffect(() => {
    const arrData = [];
    arrData.push({
      icon: zipCar,
      title: "เขตชุมชน",
      text: "ความเร็วไม่เกิน 30 - 60 กม./ชม.",
      value: dataSource.community ?? 0,
      percent: ((dataSource.community ?? 0) * 100) / (dataSource.total ?? 0),
    });
    arrData.push({
      icon: bitbank,
      title: "จำกัดความเร็ว",
      text: "ความเร็วเกิน 30 - 90 กม./ชม.",
      value: dataSource.speedLimit ?? 0,
      percent: ((dataSource.speedLimit ?? 0) * 100) / (dataSource.total ?? 0),
    });
    arrData.push({
      icon: aviato,
      title: "พื้นที่เสี่ยง",
      text: "ไหล่ทาง, ทางร่วม, ทางแยก, ไฟแดง, กิ่งไม้ ...อื่นๆ",
      value: dataSource.dangerous ?? 0,
      percent: ((dataSource.dangerous ?? 0) * 100) / (dataSource.total ?? 0),
    });
    arrData.sort((a, b) => (a.value < b.value ? 1 : -1));
    setData(arrData);
  }, [dataSource]);

  /*useEffect(() => {
    if (!alarmReal) {
      return;
    }
    setTogle(false);
    setTimeout(() => {
      setDataSource((previusData) => {
        const tmp = { ...previusData };
        if (alarmReal.CategoryID === 0) {
          tmp.community++;
        }
        if (alarmReal.CategoryID === 1) {
          tmp.speedLimit++;
        }
        if (alarmReal.CategoryID === 2) {
          tmp.dangerous++;
        }
        tmp.total++;
        return tmp;
      });
      setTogle(true);
    }, 200);
  }, [alarmReal]);*/

  return (
    <Card
      sx={{
        height: "100%",
        minHeight: 390,
        p: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        title={"การแจ้งเตือนทั้งหมด"}
        titleTypographyProps={{ variant: "subtitle1", whiteSpace: "nowrap" }}
      />
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Stack spacing={0.5}>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Typography
              className={status ? "animate__animated animate__bounceIn" : ""}
              variant="h4"
            >
              {formatNumber(dataSource.total ?? 0)} ครั้ง
            </Typography>
            <Stack direction="row">
              {(((dataSource.total ?? 0) - (dataSource.lastMonth ?? 0)) /
                (dataSource.lastMonth ?? 0)) *
                100 >=
              0 ? (
                <ExpandLess sx={{ color: green[500] }} />
              ) : (
                <ExpandMore sx={{ color: red[500] }} />
              )}
              <Typography
                color={
                  (((dataSource.total ?? 0) - (dataSource.lastMonth ?? 0)) /
                    (dataSource.lastMonth ?? 0)) *
                    100 >=
                  0
                    ? green[500]
                    : red[500]
                }
              >
                {dataSource.total || dataSource.lastMonth
                  ? formatNumber(
                      Math.abs(
                        (((dataSource.total ?? 0) -
                          (dataSource.lastMonth ?? 0)) /
                          (dataSource.lastMonth ?? 0)) *
                          100
                      ).toFixed(3)
                    )
                  : 0}
                %
              </Typography>
            </Stack>
          </Stack>
          <Typography color="text.secondary">
            เทียบกับ {formatNumber(dataSource.lastMonth ?? 0)} ครั้ง
            เมื่อเดือนที่แล้ว
          </Typography>
        </Stack>
        <Box
          sx={{
            mt: 3,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {data.map((ele, index) => (
            <Items key={index} {...ele} index={index} />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

export default AllNotifications;
